import { render } from "./Cooperate.vue?vue&type=template&id=a5d2721e&scoped=true"
const script = {}

import "./Cooperate.vue?vue&type=style&index=0&id=a5d2721e&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d2721e"]])

export default __exports__